import React, { useCallback } from 'react';

import { useHistory } from 'react-router-dom';
import { t } from 'ttag';

import { Heading } from '@components';
import { Breadcrumbs } from '@modules';
import QuickHelp from '../components/QuickHelp/QuickHelp';
import { Banners, Categories, Questions, Unibot } from '../components';
import quickHelpLinks from '../components/QuickHelp/quickHelpLinks';

export default function FAQ() {
  const history = useHistory();
  const currentDomain = window.location.hostname;

  const domainMap = {
    da: 'www.unisport.dk',
    no: 'www.unisportstore.no',
    sv: 'www.unisportstore.se',
    de: 'www.unisportstore.de',
    at: 'www.unisportstore.at',
    fr: 'www.unisportstore.fr',
    nl: 'www.unisportstore.nl',
    en: 'www.unisportstore.com',
    fi: 'www.unisportstore.fi',
    pl: 'www.unisport.pl'
  };

  const allowedDomains = Object.keys(quickHelpLinks)
    .map(code => domainMap[code])
    .filter(Boolean);

  const handleHistoryPush = useCallback(
    (event, url) => {
      event.preventDefault();
      history.push(url);
    },
    [history]
  );
  return (
    <div className="min-h-screen bg-whisper pb-8 md:pb-16">
      <div className="container space-y-8 px-0 py-4 sm:px-2 sm:py-8 md:space-y-16">
        <section>
          <Breadcrumbs>
            <Breadcrumbs.Breadcrumb href="/">{t`Frontpage`}</Breadcrumbs.Breadcrumb>

            <Breadcrumbs.Breadcrumb
              href="/faq/"
              isActive
              onClick={event => handleHistoryPush(event, '/')}
            >
              {t`FAQ`}
            </Breadcrumbs.Breadcrumb>
          </Breadcrumbs>
          <Heading as="h1" className="font-black md:col-span-2">
            {t`Frequently Asked Questions`}
          </Heading>
          <Unibot />
          <Banners />
        </section>
        {allowedDomains.includes(currentDomain) && <QuickHelp />}
        <main className="space-y-8">
          <Heading as="h2" className="break-words text-3xl normal-case">
            {t`How can we help you?`}
          </Heading>
          <div className="space-y-8 lg:grid lg:grid-cols-3 lg:gap-16 lg:space-y-0">
            <section className="space-y-4 lg:col-span-2">
              <Categories />
            </section>

            <section className="space-y-4 lg:col-span-1">
              <Heading as="h2" className="break-words font-black">
                {t`Popular Questions`}
              </Heading>
              <Questions isPopular />
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
